import { drop, split, join, forEach, isEmpty, get, first, find } from "lodash";
import Cookies from 'js-cookie';

export const getClientIdFromCookie = () => {
    let clientId = '0000000.0000000';
    const gacookie = Cookies.get('_ga');
    if (gacookie) {
      const gacookieParts = drop(split(gacookie, '.'), 2);
      clientId = join(gacookieParts, '.');
    }
    return clientId;
  };

// PRODUCT STORE
export const isOnStock = store => {
  return find(store, storeEntry => get(storeEntry, 'count', 0) > 0)
    ? true
    : false;
};

export const isStockOnTheWay = store => {
  const stocks = getStockOnTheWayInfo(store);
  let stockCumulative = 0;
  forEach(stocks, stock => {
    if (stock.storeDeliveryCount) {
      stockCumulative = stockCumulative + parseInt(stock.storeDeliveryCount, 10);
    }
  });
  return stockCumulative > 0 ? true : false;
};

export const getStockOnTheWayInfo = store => {
  let stocks = [];
  forEach(store, storeEntry => {
    forEach(get(storeEntry, 'storeData', []), storeDataEntry => {
      stocks.push(storeDataEntry);
    });
  });

  return stocks;
};

export const isOnSupplierStoreOnly = (stores) => {
  if (stores.length === 1) {
    const store = first(stores);
    const storeData = get(store, 'storeData', null);
    return (
      !isEmpty(storeData) &&
      storeData.length === 1 &&
      get(first(storeData), 'storeName', null) === 'Dodavatelský sklad'
    );
  }

  return false;
};